module.exports = __webpack_public_path__ + "img/BOX_rulesheet.8215a5b0.png";